import Vue from 'vue'

/** mutation type identifiers */
export const SET_SECTIONS = 'setSections'
export const FETCH_SECTIONS = 'fetchSections'

export default {
  namespaced: true,

  /** default state */
  state: {
    sections: [],
  },

  /** mutations */
  mutations: {
    [SET_SECTIONS](state, sections) {
      state.sections = sections
    },
  },

  /** actions */
  actions: {
    [SET_SECTIONS]({ commit }, sections) {
      commit(SET_SECTIONS, sections)
    },

    [FETCH_SECTIONS]({ commit }) {
      return Vue.$http.get('admin-settings/sections').then(response => {
        commit(SET_SECTIONS, response.data)
      })
    },
  },

  /** getters */
  getters: {
    sections: state => state.sections,
  },
}
